import React from "react";
import Container from "../components/ui/Container/Container";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { useAuthContext } from "../context/auth-context";

const ApiDocsPage: React.FC = () => {
  const { user } = useAuthContext();

  if (!user || (user.role !== "ADMIN" && user.role !== "SUPERADMIN")) {
    return (
      <Container>
        <p>Access denied.</p>
      </Container>
    );
  }

  return (
    <>
      <PageHeading>API Documentation & Sandbox</PageHeading>
      <Container>
        <div style={{ marginBottom: "1rem", padding: "1rem", background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
          <h4 style={{ margin: "0 0 0.5rem 0", color: "#1b2a4a" }}>Developer Sandbox Quick Tips</h4>
          <p style={{ margin: "0 0 0.5rem 0", fontSize: "0.9rem", color: "#495057" }}>
            Click the green <strong>Authorize</strong> button below to set your <code>X-API-KEY</code> header.
            For development / testing, you can use the test key: <code>1ad4c9a325af5f56</code>.
          </p>
          <div style={{ display: "flex", gap: "1rem", fontSize: "0.85rem" }}>
            <a 
              href="/openapi.json" 
              target="_blank" 
              rel="noreferrer" 
              download="openapi.json"
              style={{ color: "#007bff", textDecoration: "underline" }}
            >
              ⬇ Download OpenAPI Specification (JSON)
            </a>
            <a 
              href="/api-docs.html" 
              target="_blank" 
              rel="noreferrer" 
              style={{ color: "#007bff", textDecoration: "underline" }}
            >
              ↗ Open in Fullscreen Window
            </a>
          </div>
        </div>

        <div style={{ border: "1px solid #ddd", borderRadius: "8px", overflow: "hidden", minHeight: "750px", background: "#fff" }}>
          <iframe
            src="/api-docs.html"
            title="Swagger API Documentation"
            style={{ width: "100%", height: "800px", border: "none" }}
          />
        </div>
      </Container>
    </>
  );
};

export default ApiDocsPage;
